import { useTooltipDisplayContext } from '../../common/tooltip/tooltip.context'
import { DEFAULT_STRING_JOIN } from '../table.constants'
import { cellFormatService } from './cell-format.service'

import { useStyles } from './cell-format.style'

export const TextCell = ({ values, formatOptions, isLastCell }) => {
  const classes = useStyles()

  const [, setTooltipDisplayData] = useTooltipDisplayContext()

  const defaultStyles = { textAlign: 'left' }
  const displayValue = values.join(formatOptions.join || DEFAULT_STRING_JOIN)
  const className = cellFormatService.mapFormatOptionsToClassName(
    formatOptions,
    classes
  )
  const style = cellFormatService.mapFormatOptionsToStyle(
    formatOptions,
    defaultStyles,
    isLastCell
  )

  function showTooltip () {
    if (formatOptions.label) {
      setTooltipDisplayData({
        primaryValue: formatOptions.label
      })
    }
  }

  function hideTooltip () {
    if (formatOptions.label) {
      setTooltipDisplayData()
    }
  }

  return (
    <div
      className={`${classes.textCell} ${className}`}
      style={style}
      onMouseMove={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {displayValue}
    </div>
  )
}
